module.exports = __webpack_public_path__ + "img/tradein4.51460097.jpg";